import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { IStoreState } from "../../../../../../reducers/types";
import { TravelAppPage } from "./component";
import {
  getAirportMap,
  getSelectedCar,
  getSelectedExperience,
  getSelectedFlight,
  getSelectedHome,
  getSelectedHotel,
  getSelectedPackage,
} from "../../../../reducer";
import {
  fetchCars,
  fetchExperiences,
  fetchFlights,
  fetchHomes,
  fetchHotels,
  fetchPackages,
} from "../../../../actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  selectedFlight: getSelectedFlight(state),
  selectedHotel: getSelectedHotel(state),
  selectedHome: getSelectedHome(state),
  selectedCar: getSelectedCar(state),
  selectedPackage: getSelectedPackage(state),
  selectedExperience: getSelectedExperience(state),
  airportMap: getAirportMap(state),
});

const mapDispatchToProps = {
  fetchCars,
  fetchFlights,
  fetchHotels,
  fetchPackages,
  fetchExperiences,
  fetchHomes,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type TravelAppPageConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedTravelAppPage = connector(withRouter(TravelAppPage));
